import React from "react";
import { useSelector } from "react-redux";
import Tabs from "../portrait/Tabs";
import ArrowKeyset from "./ArrowKeyset";
import NumberKeyset from "./numberKeyset/NumberKeyset";
import AlphabetKeyset from "./alphabetKeyset/AlphabetKeyset";

const Mini = ( props ) => {

  const keypad = useSelector( state => state.keypad );

  const {
    children,
    ...PROPS
  } = props;

  return (
    <div className="keypad_gm middle mob tab-wrap hide_pc hide_th hide_tv">
      <div className="upper_area cls">
        <Tabs { ...PROPS } />
        <div className="right">
          <ArrowKeyset { ...PROPS } />
        </div>
      </div>
      <div className="mid_area">
        { '0' === keypad.tabIndex ? <NumberKeyset { ...PROPS } /> : <AlphabetKeyset { ...PROPS } /> }
      </div>
      <div className="lower_area">{ props.children }</div>
    </div>
  );

};

export default Mini;
